<template>
    <div class="flex justify-end items-center">
        <span class="mr-2">
            <IconLang class="font-size-24 icon-lang-color" />
        </span>
        <div class="flex flag-box">
            <a
                v-for="lang in supportedLanguages"
                @click.prevent="changeLang(lang)"
                :key="lang"
                :class="[currentLang == lang ? 'active' : null, 'flex items-center flag sprite-flag', `sprite-${lang}`]"
                :title="lang"
                href="#"
            >
            </a>
        </div>
    </div>
</template>

<script>
import { loadLanguageAsync } from '@/i18n/index.js'
import Cookies from 'js-cookie'
import appConfig from '../app.config.js'
import IconLang from '@/components/IconLang.vue'

export default {
    components: {
        IconLang
    },

    created() {
        this.setFlag()
    },

    computed: {
        supportedLanguages() {
            return appConfig.supportedLanguages
        }
    },

    data() {
        return {
            currentLang: 'en'
        }
    },

    methods: {
        async changeLang(lang) {
            const setLang = await loadLanguageAsync(lang)

            Cookies.set('lang', setLang, {
                expires: 365
            })

            this.setFlag()
            this.$emit('close')
        },

        setFlag() {
            const currentLang = Cookies.get('lang')
            this.currentLang = !currentLang ? 'en' : currentLang
        }
    }
}
</script>

<style lang="scss">
.icon-lang-color {
    fill: var(--ui-primary-color);
}

.flag-box {
    padding: 0.4em 0.5em;
    column-gap: 8px;

    .flag {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        overflow: hidden;
        opacity: 0.3;
        display: block;
        padding: 0 !important;

        &:hover {
            background-color: #f5f5f5;
            cursor: pointer;
        }

        img {
            width: 120%;
            height: 120%;
            object-fit: cover;
        }

        &.active {
            opacity: 1;
        }
    }
}

.sprite-flag {
    background-image: url('../../../public/images/flags.png');
    background-repeat: no-repeat;
    background-size: 95px;
    display: block;
}

.sprite-en {
    background-position: -5px -1px;
}

.sprite-no {
    background-position: -35px -1px;
}

.sprite-se {
    background-position: -3px -26px;
}

.sprite-dk {
    background-position: -36px -26px;
}

.sprite-fr {
    background-position: -70px -1px;
}

.sprite-de {
    background-position: -70px -26px;
}

.sprite-es {
    background-position: -3px -52px;
}
</style>
